import {parseResponse} from '../../../helpers/api'
import client from '../../../client'

export default {
    async getSuitableSystemId() {
        return client.v1.get(`/cases/get-suitable-system-id`).then((response) => {
            return parseResponse(response)
        })
    },
    async checkSystemId(systemId) {
        return client.v1.get(`/cases/check-system-id`, {
            params: {
                systemId: systemId,
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async checkOverriddenSystemId(overriddenSystemId) {
        return client.v1.get(`/cases/check-overridden-system-id`, {
            params: {
                overriddenSystemId: overriddenSystemId
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async createCase(caseData) {
        return client.v1.post(`/cases/create`, caseData).then((response) => {
            return parseResponse(response)
        })
    },
    async updateCase(caseData) {
        return client.v1.post(`/cases/update`, caseData).then((response) => {
            return parseResponse(response)
        })
    },
    async addFileToReport(reportId, fileId) {
        let response = null
        try {
            response = await client.v1.post(`/reports/add-file`, {
                reportId: reportId,
                fileId: fileId
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
    async deleteFileFromReport(reportId, fileId) {
        let response = null
        try {
            response = await client.v1.post(`/reports/delete-file`, {
                reportId: reportId,
                fileId: fileId
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
    async actualizeReportData(reportId, reason) {
        let response = null
        try {
            response = await client.v2.post(`/reports/actualize-data`, {
                reportId: reportId,
                reason: reason
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
    async getCase(systemId) {
        return client.v1.get(`/cases/get-case`, {
            params: {
                systemId: systemId
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async getCases(skip, limit, filters, sortBy, order) {
        return client.v1.get(`/cases/get`, {
            params: {
                skip: skip,
                limit: limit,
                sortBy: sortBy,
                order: order,
                filters: filters
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async getCasesByPatient(patientId) {
        return client.v1.get(`/cases/get-by-patient`, {
            params: {
                patientId: patientId,
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async createReport(reportData) {
        return client.v1.post(`/reports/create`, reportData).then((response) => {
            return parseResponse(response)
        })
    },
    async copyReport(reportId) {
        return client.v1.post(`/reports/copy`, {
            reportId: reportId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async updateReport(reportData) {
        return client.v1.post(`/reports/update`, reportData).then((response) => {
            return parseResponse(response)
        })
    },
    async deleteReport(reportId) {
        return client.v1.post(`/reports/delete`, {
            reportId: reportId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async addSpecialistToReport(reportId, specialistId) {
        return client.v1.post(`/reports/add-specialist`, {
            reportId: reportId,
            specialistId: specialistId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async deleteSpecialistFromReport(reportId, specialistId) {
        return client.v1.post(`/reports/delete-specialist`, {
            reportId: reportId,
            specialistId: specialistId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async signReport(reportId, specialistId) {
        return client.v1.post(`/reports/sign`, {
            reportId: reportId,
            specialistId: specialistId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async deleteSignFromReport(reportId, specialistId) {
        return client.v1.post(`/reports/delete-sign`, {
            reportId: reportId,
            specialistId: specialistId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async sendReport(reportId) {
        return client.v1.post(`/reports/send`, {
            id: reportId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async downloadReport(id, format, withoutSignatures = false, withoutStamp = false) {
        let accept = ''
        switch (format) {
            case 'pdf':
                accept = 'application/pdf'
                break;
            case 'docx':
                accept = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }

        return client.v1.get(`/reports/download`, {
            params: {
                id: id,
                format: format,
                withoutSignatures: withoutSignatures,
                withoutStamp: withoutStamp
            },
            responseType: 'arraybuffer',
            headers: {
                'Accept': accept
            }
        }).then((response) => {
            return response.data
        })
    },
    async getSuitableBatch(samplesCount) {
        return client.v1.get(`/batches/get-suitable-batch`, {
            params: {
                samplesCount: samplesCount
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async resetSampleDueDaysCounter(sampleId) {
        let response = null
        try {
            response = await client.v1.post(`/samples/reset-due-days-counter`, {
                sampleId: sampleId
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
}